import { FC, memo } from 'react';
import { CgClose } from 'react-icons/cg';
import { Box, Flex, Icon, Stack, Text, useSlotRecipe } from '@chakra-ui/react';

import { BlocksRenderer } from '../../../../../application/components';
import { EMPTY_OBJ } from '../../../../constants';
import { useAccordionRadioGroupRenderableIcon } from '../hooks/useAccordionRadioGroupRenderableIcon';
import { SelectedAccordionRadioOptionProps } from './types/SelectedAccordionRadioOptionProps';

const SelectedAccordionRadioOptionComponent: FC<
  SelectedAccordionRadioOptionProps
> = ({
  onClearSelectedOption,
  selectedGroup,
  selectedOption,
  footer,
  cardProps = EMPTY_OBJ,
}) => {
  const RenderableIcon = useAccordionRadioGroupRenderableIcon(
    selectedGroup.icon,
  );
  const assetImageRecipe = useSlotRecipe({ key: 'assetImage' });
  const assetImageStyles = assetImageRecipe();
  return (
    <Stack
      bg="brandSecondary.subtle"
      borderRadius="sm"
      gap={4}
      p={4}
      {...cardProps}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex>
          <Icon
            as={RenderableIcon}
            boxSize={12}
            css={assetImageStyles.assetIcon}
            mr={4}
          />
          <Box>
            <Text fontSize="sm">{selectedGroup.label}</Text>
            <Text fontSize="lg" fontWeight="bold">
              {selectedOption.value}
            </Text>
          </Box>
        </Flex>

        <button onClick={onClearSelectedOption} type="button">
          <Icon as={CgClose} boxSize={6} color="brandSecondary.fg" />
        </button>
      </Flex>

      {footer && (
        <BlocksRenderer
          blocks={footer.blocks}
          namePrefixes={footer.namePrefixes}
        />
      )}
    </Stack>
  );
};

export const SelectedAccordionRadioOption = memo(
  SelectedAccordionRadioOptionComponent,
);
